<template>
    <div class="wf-input-mobile">
        <div class="wf-input-mobile-label">{{label}}</div>
        <div class="wf-input-mobile-input">
            <input type="text" v-model="componentValue" @input="handleInput" :placeholder="placeholder">
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: ""
        },
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: '请输入'
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    data() {
        return {
            componentValue: ''
        }
    },
    mounted() {
        this.componentValue = this.value
    },
    methods: {
        handleInput(event) {
            this.$emit('change', event.target.value)
        }
    },
    watch: {
        value(newValue) {
            this.componentValue = newValue
        }
    }
}
</script>

<style lang="scss" scoped>
.wf-input-mobile {
    display: flex;
    flex-direction: row;
    align-items: center;
    .wf-input-mobile-label {
        font-size: 0.26rem;
        color: #666;
    }
    .wf-input-mobile-input {
        flex: 1;
        margin-left: 0.14rem;
        height: 0.6rem;
        border: 0.02rem solid #e0e0e0;
        > input {
            display: block;
            width: 100%;
            height: 100%;
            padding-left: 0.16rem;
            font-size: 0.26rem;
            color: #333;
            border: none;
            outline: none;
        }
        input::-webkit-input-placeholder {
            color: #ccc;
        }
        input::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: #ccc;
        }
        input:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: #ccc;
        }
        input:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: #ccc;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/inputMobile/inputMobile.vue